// Generated from ./util_cohort_builder_grammar/stable/DateAttributesLexer.g4 by ANTLR 4.13.1

import * as antlr from "antlr4ng";
import { Token } from "antlr4ng";


export class DateAttributesLexer extends antlr.Lexer {
    public static readonly CONDITION_OCCURRENCE_DATE_ATTRIBUTE = 1;
    public static readonly DRUG_EXPOSURE_DATE_ATTRIBUTE = 2;
    public static readonly MEASUREMENT_DATE_ATTRIBUTE = 3;
    public static readonly OBSERVATION_DATE_ATTRIBUTE = 4;
    public static readonly PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE = 5;
    public static readonly VISIT_OCCURRENCE_DATE_ATTRIBUTE = 6;
    public static readonly PERSON_DATE_TIME_ATTRIBUTE = 7;

    public static readonly channelNames = [
        "DEFAULT_TOKEN_CHANNEL", "HIDDEN"
    ];

    public static readonly literalNames = [
        null, null, null, "'measurement_date'", "'observation_date'", "'procedure_date'", 
        null, "'birth_datetime'"
    ];

    public static readonly symbolicNames = [
        null, "CONDITION_OCCURRENCE_DATE_ATTRIBUTE", "DRUG_EXPOSURE_DATE_ATTRIBUTE", 
        "MEASUREMENT_DATE_ATTRIBUTE", "OBSERVATION_DATE_ATTRIBUTE", "PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE", 
        "VISIT_OCCURRENCE_DATE_ATTRIBUTE", "PERSON_DATE_TIME_ATTRIBUTE"
    ];

    public static readonly modeNames = [
        "DEFAULT_MODE",
    ];

    public static readonly ruleNames = [
        "CONDITION_OCCURRENCE_DATE_ATTRIBUTE", "DRUG_EXPOSURE_DATE_ATTRIBUTE", 
        "MEASUREMENT_DATE_ATTRIBUTE", "OBSERVATION_DATE_ATTRIBUTE", "PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE", 
        "VISIT_OCCURRENCE_DATE_ATTRIBUTE", "PERSON_DATE_TIME_ATTRIBUTE",
    ];


    public constructor(input: antlr.CharStream) {
        super(input);
        this.interpreter = new antlr.LexerATNSimulator(this, DateAttributesLexer._ATN, DateAttributesLexer.decisionsToDFA, new antlr.PredictionContextCache());
    }

    public get grammarFileName(): string { return "DateAttributesLexer.g4"; }

    public get literalNames(): (string | null)[] { return DateAttributesLexer.literalNames; }
    public get symbolicNames(): (string | null)[] { return DateAttributesLexer.symbolicNames; }
    public get ruleNames(): string[] { return DateAttributesLexer.ruleNames; }

    public get serializedATN(): number[] { return DateAttributesLexer._serializedATN; }

    public get channelNames(): string[] { return DateAttributesLexer.channelNames; }

    public get modeNames(): string[] { return DateAttributesLexer.modeNames; }

    public static readonly _serializedATN: number[] = [
        4,0,7,199,6,-1,2,0,7,0,2,1,7,1,2,2,7,2,2,3,7,3,2,4,7,4,2,5,7,5,2,
        6,7,6,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,
        0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,
        0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,3,0,54,8,0,1,1,1,1,1,1,1,1,1,1,1,1,
        1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,
        1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,
        1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,3,1,102,8,1,1,2,1,2,1,2,1,2,1,2,
        1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,3,1,3,1,3,1,3,
        1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,4,1,4,1,4,
        1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,5,1,5,1,5,1,5,
        1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,
        1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,3,5,183,8,5,1,6,1,6,1,6,
        1,6,1,6,1,6,1,6,1,6,1,6,1,6,1,6,1,6,1,6,1,6,1,6,0,0,7,1,1,3,2,5,
        3,7,4,9,5,11,6,13,7,1,0,0,201,0,1,1,0,0,0,0,3,1,0,0,0,0,5,1,0,0,
        0,0,7,1,0,0,0,0,9,1,0,0,0,0,11,1,0,0,0,0,13,1,0,0,0,1,53,1,0,0,0,
        3,101,1,0,0,0,5,103,1,0,0,0,7,120,1,0,0,0,9,137,1,0,0,0,11,182,1,
        0,0,0,13,184,1,0,0,0,15,16,5,99,0,0,16,17,5,111,0,0,17,18,5,110,
        0,0,18,19,5,100,0,0,19,20,5,105,0,0,20,21,5,116,0,0,21,22,5,105,
        0,0,22,23,5,111,0,0,23,24,5,110,0,0,24,25,5,95,0,0,25,26,5,115,0,
        0,26,27,5,116,0,0,27,28,5,97,0,0,28,29,5,114,0,0,29,30,5,116,0,0,
        30,31,5,95,0,0,31,32,5,100,0,0,32,33,5,97,0,0,33,34,5,116,0,0,34,
        54,5,101,0,0,35,36,5,99,0,0,36,37,5,111,0,0,37,38,5,110,0,0,38,39,
        5,100,0,0,39,40,5,105,0,0,40,41,5,116,0,0,41,42,5,105,0,0,42,43,
        5,111,0,0,43,44,5,110,0,0,44,45,5,95,0,0,45,46,5,101,0,0,46,47,5,
        110,0,0,47,48,5,100,0,0,48,49,5,95,0,0,49,50,5,100,0,0,50,51,5,97,
        0,0,51,52,5,116,0,0,52,54,5,101,0,0,53,15,1,0,0,0,53,35,1,0,0,0,
        54,2,1,0,0,0,55,56,5,100,0,0,56,57,5,114,0,0,57,58,5,117,0,0,58,
        59,5,103,0,0,59,60,5,95,0,0,60,61,5,101,0,0,61,62,5,120,0,0,62,63,
        5,112,0,0,63,64,5,111,0,0,64,65,5,115,0,0,65,66,5,117,0,0,66,67,
        5,114,0,0,67,68,5,101,0,0,68,69,5,95,0,0,69,70,5,115,0,0,70,71,5,
        116,0,0,71,72,5,97,0,0,72,73,5,114,0,0,73,74,5,116,0,0,74,75,5,95,
        0,0,75,76,5,100,0,0,76,77,5,97,0,0,77,78,5,116,0,0,78,102,5,101,
        0,0,79,80,5,100,0,0,80,81,5,114,0,0,81,82,5,117,0,0,82,83,5,103,
        0,0,83,84,5,95,0,0,84,85,5,101,0,0,85,86,5,120,0,0,86,87,5,112,0,
        0,87,88,5,111,0,0,88,89,5,115,0,0,89,90,5,117,0,0,90,91,5,114,0,
        0,91,92,5,101,0,0,92,93,5,95,0,0,93,94,5,101,0,0,94,95,5,110,0,0,
        95,96,5,100,0,0,96,97,5,95,0,0,97,98,5,100,0,0,98,99,5,97,0,0,99,
        100,5,116,0,0,100,102,5,101,0,0,101,55,1,0,0,0,101,79,1,0,0,0,102,
        4,1,0,0,0,103,104,5,109,0,0,104,105,5,101,0,0,105,106,5,97,0,0,106,
        107,5,115,0,0,107,108,5,117,0,0,108,109,5,114,0,0,109,110,5,101,
        0,0,110,111,5,109,0,0,111,112,5,101,0,0,112,113,5,110,0,0,113,114,
        5,116,0,0,114,115,5,95,0,0,115,116,5,100,0,0,116,117,5,97,0,0,117,
        118,5,116,0,0,118,119,5,101,0,0,119,6,1,0,0,0,120,121,5,111,0,0,
        121,122,5,98,0,0,122,123,5,115,0,0,123,124,5,101,0,0,124,125,5,114,
        0,0,125,126,5,118,0,0,126,127,5,97,0,0,127,128,5,116,0,0,128,129,
        5,105,0,0,129,130,5,111,0,0,130,131,5,110,0,0,131,132,5,95,0,0,132,
        133,5,100,0,0,133,134,5,97,0,0,134,135,5,116,0,0,135,136,5,101,0,
        0,136,8,1,0,0,0,137,138,5,112,0,0,138,139,5,114,0,0,139,140,5,111,
        0,0,140,141,5,99,0,0,141,142,5,101,0,0,142,143,5,100,0,0,143,144,
        5,117,0,0,144,145,5,114,0,0,145,146,5,101,0,0,146,147,5,95,0,0,147,
        148,5,100,0,0,148,149,5,97,0,0,149,150,5,116,0,0,150,151,5,101,0,
        0,151,10,1,0,0,0,152,153,5,118,0,0,153,154,5,105,0,0,154,155,5,115,
        0,0,155,156,5,105,0,0,156,157,5,116,0,0,157,158,5,95,0,0,158,159,
        5,115,0,0,159,160,5,116,0,0,160,161,5,97,0,0,161,162,5,114,0,0,162,
        163,5,116,0,0,163,164,5,95,0,0,164,165,5,100,0,0,165,166,5,97,0,
        0,166,167,5,116,0,0,167,183,5,101,0,0,168,169,5,118,0,0,169,170,
        5,105,0,0,170,171,5,115,0,0,171,172,5,105,0,0,172,173,5,116,0,0,
        173,174,5,95,0,0,174,175,5,101,0,0,175,176,5,110,0,0,176,177,5,100,
        0,0,177,178,5,95,0,0,178,179,5,100,0,0,179,180,5,97,0,0,180,181,
        5,116,0,0,181,183,5,101,0,0,182,152,1,0,0,0,182,168,1,0,0,0,183,
        12,1,0,0,0,184,185,5,98,0,0,185,186,5,105,0,0,186,187,5,114,0,0,
        187,188,5,116,0,0,188,189,5,104,0,0,189,190,5,95,0,0,190,191,5,100,
        0,0,191,192,5,97,0,0,192,193,5,116,0,0,193,194,5,101,0,0,194,195,
        5,116,0,0,195,196,5,105,0,0,196,197,5,109,0,0,197,198,5,101,0,0,
        198,14,1,0,0,0,4,0,53,101,182,0
    ];

    private static __ATN: antlr.ATN;
    public static get _ATN(): antlr.ATN {
        if (!DateAttributesLexer.__ATN) {
            DateAttributesLexer.__ATN = new antlr.ATNDeserializer().deserialize(DateAttributesLexer._serializedATN);
        }

        return DateAttributesLexer.__ATN;
    }


    private static readonly vocabulary = new antlr.Vocabulary(DateAttributesLexer.literalNames, DateAttributesLexer.symbolicNames, []);

    public override get vocabulary(): antlr.Vocabulary {
        return DateAttributesLexer.vocabulary;
    }

    private static readonly decisionsToDFA = DateAttributesLexer._ATN.decisionToState.map( (ds: antlr.DecisionState, index: number) => new antlr.DFA(ds, index) );
}